<template>
<el-row>
    <el-col>
        <span class="cs-title">课程记录</span>
        <el-row class="hidden-xs-only">
            <el-col :span="18">
                <label> &nbsp; </label>
            </el-col>
        </el-row>
        <el-row class="grid-content">
            <el-col :span="22" :xs="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>大学课程</span> 
                    </div>
                     <studentSpeedupCourseHistoryList :contractList="contractList" :studentName="studentName" :studentId="studentId" :courseType="GLOBAL.courseType.university" :courseRecords="courseList" :enableEdit="enableEdit" :loading="courseRecordsLoading" @reload-course-records="initData"></studentSpeedupCourseHistoryList>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>应试英语</span>
                    </div>
                    <studentSpeedupCourseHistoryList :contractList="contractList" :studentName="studentName" :studentId="studentId" :courseType="GLOBAL.courseType.english" :courseRecords="englishTrainingCourseList" :loading="courseRecordsLoading"></studentSpeedupCourseHistoryList>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>职业培训课程</span>
                    </div>
                    <studentSpeedupCourseHistoryList :contractList="contractList" :campusList="campusList" :studentName="studentName" :studentId="studentId" :courseType="GLOBAL.courseType.vocationalTraining" :courseRecords="trainingCourseList" :enableEdit="enableEdit" :loading="courseRecordsLoading"></studentSpeedupCourseHistoryList>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>新生引流</span>
                    </div>
                    <studentSpeedupCourseHistoryList :contractList="contractList" :studentName="studentName" :studentId="studentId" :courseType="GLOBAL.courseType.newStudentGuide" :courseRecords="newStudentGuideCourseList" :loading="courseRecordsLoading"></studentSpeedupCourseHistoryList>
                </el-card>
            </el-col>
        </el-row>
    </el-col>
</el-row>
</template>

<style lang="scss" scoped>
.courses-history-colmun-width {
    min-width: 120px;
}
.course-score-selector{
    height: 30px;
    line-height: 30px;
    width: 100px;
}
.el-card{
    margin-top: 20px;

    &:first-of-type{
        margin-top: 0;
    }
}
</style>

<script>
import { getContractViewModelList } from "@/service/contract.service";
import studentSpeedupCourseHistoryList from "./studentSpeedupCourseHistoryList";
import { 
    getStudentCourseupCourseRecords,
} from "../../service/student.service";
import{
    getCampusList
} from "@/service/common.service"

export default {
    props: {
        studentName: String,
        studentId: Number,
        enableEdit: Boolean
    },
    components:{
        studentSpeedupCourseHistoryList
    },
    data() {
        return {
          contractList: [],
          courseList: [],
          trainingCourseList: [],
          englishTrainingCourseList: [],
          newStudentGuideCourseList: [],
          campusList:[],
          courseRecordsLoading: false
        }
    },
    created() {
        getCampusList().then(result => {
            if (!!result && result.success) {
                this.campusList = result.data;
            }
        });
        this.initContractList();
        this.initData();
    },
    methods: {
        initContractList() {
            getContractViewModelList().then(result => {
                if (!!result && result.success) {
                    this.contractList = result.data;
                }
            });
        },
        initData() {
            this.courseRecordsLoading = true;
            getStudentCourseupCourseRecords(this.studentId)
                .then(result => {
                    if (!!result && result.success) {
                        let list = result.data;
                        this.courseList = list.filter(i => i.CourseType == this.GLOBAL.courseType.university);
                        this.trainingCourseList = list.filter(i => i.CourseType == this.GLOBAL.courseType.vocationalTraining);
                        this.englishTrainingCourseList = list.filter(i => i.CourseType === this.GLOBAL.courseType.english);
                        this.newStudentGuideCourseList = list.filter(i => i.CourseType === this.GLOBAL.courseType.newStudentGuide);
                    }
                })
                .finally(() => {
                    this.courseRecordsLoading = false;
                });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/studentProfile/studentSpeedupCourseHistory.vue